import React from 'react';
import { useSelector } from 'react-redux';
import {
  PromptGroup,
  PromptItemKind,
} from '../../../../types/candidateStories';
import { findItemTranslation } from './promptGroupHelpers';
import CandidateStoryItemTextField from './CandidateStoryItemTextField';
import * as V from '../../../../lib/validations/candidateStoryValidations';

const CandidateStoryPromptTextForm = ({
  promptGroup,
  disabled,
  recordId,
}: {
  promptGroup: PromptGroup | null;
  disabled: boolean;
  recordId?: string;
}) => {
  const currentLanguage = useSelector(
    (state: { i18n: { locale: string } }) => state.i18n.locale,
  );

  if (disabled || !promptGroup || promptGroup.items.length === 0) {
    return null;
  }
  const textItems = promptGroup.items.filter(
    item => item.kind === PromptItemKind.TEXT,
  );

  if (textItems.length === 0) {
    return null;
  }

  const customValidations = [V.validateMinLength, V.maxContentLength];

  return (
    <div data-testid='candidate-story-prompt-text-form'>
      {textItems.map(item => {
        const translatedItem = findItemTranslation(item, currentLanguage);
        const itemField = recordId
          ? `candidateStories.promptGroup.content.${recordId}.${item.id}`
          : `candidateStories.promptGroup.content.general.${item.id}`;
        return (
          <div
            key={item.id}
            className='mb-3 p-3'
            data-testid={`dynamic-prompt-text-section-${item.id}`}
          >
            <h5 className='mb-2'>
              {translatedItem?.title}
              {item.required && <span className='text-danger'> *</span>}
            </h5>
            <p className='text-muted mb-2'>{translatedItem?.description}</p>
            <CandidateStoryItemTextField
              field={itemField}
              customValidations={item.required ? customValidations : []}
            />
          </div>
        );
      })}
    </div>
  );
};

export default CandidateStoryPromptTextForm;
